import authRequest from '../authRequest';
import SessionPresenter from '../../presenters/SessionPresenter';

const fetchSessionsList = async (currentPage, params = {}) => {
  const searchParams = new URLSearchParams({ page: currentPage, ...params });
  const response = await authRequest(`/sessions?${searchParams.toString()}`, { method: 'GET' });

  if (response.status !== 200) throw new Error('Fetching sessions failed');

  const sessions = response.data.sessions.map(sessionData => new SessionPresenter(sessionData));

  const pagination = {
    current: response.data.meta.current_page,
    pageSize: response.data.meta.per_page,
    total: response.data.meta.total_entries,
  };

  return { sessions, pagination };
};

export default fetchSessionsList;
